"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRMcBaseUrl = void 0;
class XHRMcBaseUrl {
    constructor() {
        this.name = this.constructor.name;
    }
    async handleRequest(request) {
        if (request.url.includes('mb-api-')) {
            request.url = request.url.replace('mb-api-', 'ods-api-');
        }
        return Promise.resolve(request);
    }
}
exports.XHRMcBaseUrl = XHRMcBaseUrl;
//# sourceMappingURL=xhrMcBaseUrl.js.map